import { Card, Inline, Skeleton, Stack } from '@cortex/ui';

/**
 * Skeleton loader for request cards.
 * Shows a placeholder card during data fetch that matches the RequestCard layout.
 *
 * Used on the Dashboard page and Project detail page.
 */
export function RequestCardSkeleton() {
  return (
    <Card className="p-4">
      <Stack gap="sm">
        <Inline justify="between" align="start" gap="sm">
          <Inline gap="sm" wrap>
            <Skeleton className="h-[22px] w-[80px]" />
            <Skeleton className="h-[22px] w-[50px]" />
          </Inline>
        </Inline>
        <Stack gap="xs">
          <Skeleton className="h-3 w-[60px]" />
          <Skeleton className="h-5 w-full" />
        </Stack>
        <Skeleton className="h-8 w-full" />
        <Inline justify="between" className="border-border border-t pt-3">
          <Inline gap="sm">
            <Skeleton className="h-6 w-6 rounded-full" />
            <Skeleton className="h-3.5 w-[80px]" />
          </Inline>
          <Skeleton className="h-3.5 w-[70px]" />
        </Inline>
      </Stack>
    </Card>
  );
}
